/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingAppointmentSyncStatusPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const BookingAppointmentSyncStatusPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentSyncStatusPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentSyncStatusPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingAppointmentSyncStatusPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


